<template>
  <div class="field-row">
    <label class="label">Support Start</label>
    <p class="field-note"><small>Your timezone: {{ userLocalTimezone }}</small></p>
    <v-layout>
      <v-flex xs12 lg6>
        <v-menu
          v-model="datePicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateString"
              label="Support Start Date"
              prepend-icon="fa fa-calendar-alt"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateString"
            @input="updateDate()"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 lg6>
        <v-menu
          ref="timePicker"
          v-model="timePicker"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="timePicker"
          transition="scale-transition"
          offset-y
          max-width="280px"
          min-width="280px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="timeString"
              label="Support Start Time"
              prepend-icon="fa fa-clock"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="timePicker"
            v-model="timeString"
            format="24hr"
            full-width
            @click:minute="updateTime()"
          ></v-time-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import log from '@/utils/log';
export default {
  name: 'JigDateTimeFields',
  data() {
    return {
      datePicker: false,
      timePicker: false,
      dateString: '',
      timeString: '',
    };
  },
  created() {
    this.dateString = this.currentDateTime.substring(0, 10);
    this.timeString = this.currentDateTime.substring(11, 16);
    this.updateDateTime();
  },
  computed: {
    currentDateTime() {
      // As in Date.toISOString function timezone is alwasy zero UTC offset, we need to manually get timezone offset in order to get local time ISO string.
      // Date.now() returns value in milliseconds, getTimezoneOffset() returns value in minutes, hence multiplying 60000
      const minInMilsec = 60000;

      return (new Date(Date.now() - (new Date()).getTimezoneOffset() * minInMilsec)).toISOString()
    },
    userLocalTimezone() {
      // toString() returns date time string in following formt:
      // "Tue Aug 03 2021 11:26:18 GMT+1000 (Australian Eastern Standard Time)"
      // Use substring to get timezone details.
      const rightNow = (new Date()).toString();

      return rightNow.substring(rightNow.indexOf('GMT'));
    },
  },
  methods: {
    updateDate() {
      this.datePicker = false;
      this.updateDateTime()
    },
    updateTime() {
      this.$refs.timePicker.save(this.timeString)
      this.updateDateTime()
    },
    updateDateTime() {
      // ISO string format: 2021-07-29T16:20:25.427Z
      const newIsoString = this.parseISOString();
      this.$emit('on-datetime-change', newIsoString);
    },
    parseISOString() {
      // Please note when using toISOString(), timezone is alwasy zero UTC offset.
      const dateString = new Date(`${this.dateString} ${this.timeString}`);

      return dateString.toISOString();
    },
  },
}
</script>
